
import { QuestionPage } from "./question-page";
import { QuestionBase } from "./question-base";

export class QuestionRoot {
    public pages : { [key : string] : QuestionPage } = {};

    public setPage( pageId: string, page: QuestionPage ) : void {
        if( pageId in this.pages ){
            console.error( 'You\'t override an existing page' );
        }

        this.pages[pageId] = page;
    }

    public getPage( pageId : string ) : QuestionPage {
        return this.pages[pageId];
    }

    public forEach( func : ( param : QuestionBase<any> ) => void ){
        for( let pageKey in this.pages ){
            this.pages[pageKey].forEach( func );
        }
    }

    public getQuestionsFlat() : { [key : string] : QuestionBase<any> } {
        let returnObject = {};

        for( let pageKey in this.pages ){
            let tmpObj = this.pages[pageKey].getQuestionsFlat();
            for( let key in tmpObj ){
                if( key in returnObject ){
                    console.error( 'what now' );
                }
            }

            returnObject = Object.assign( returnObject, tmpObj );
        }

        return returnObject;
    }

    public getQuestionsFlatArr() : Array<QuestionBase<any>> {
        return Object.values( this.getQuestionsFlat() );
    }
}


// WEBPACK FOOTER //
// ./src/app/question-root.ts